module.exports = __webpack_public_path__ + "img/qywx.0a97069d.svg";